angular.module('autoremind.reports.communication')
    .directive('appointmentsTables', [
    'dialogs', '$location', '$log', '$routeParams', 'jobService', 'messagesService', '$timeout',
    function (dialogs, $location, $log, $routeParams, jobService, messagesService, $timeout) {
        return {
            templateUrl: 'app/reports/communication/appointments-tables.html',
            restrict: 'EA',
            scope: {
                type: '=',
                viewModel: '='
            },
            link: function (scope, elem, attr) {
                jobService.job.data = {};
                scope.viewModel.job = jobService.job.data;
                scope.viewModel.browserOpen = false;
                scope.viewModel.jobId = null;
                scope.messagesService = messagesService;
                scope.jobService = jobService;
                // Used to indicate error loading stats (total messages) - mostly to hide view until loaded
                scope.message = {
                    error: false
                };
                scope.today = new Date();
                messagesService.clearModel();
                scope.openJobBrowser = function () {
                    $log.info('In autoremind.reports.ScreenController.openJobBrowser() ');
                    scope.viewModel.browserOpen = true;
                    var dialog = dialogs.create('app/communication/communications.select.job.html', 'autoremind.communications.BrowseJobController', { communicationsCategory: { communicationsCategoryId: scope.type } }, { key: false, back: 'static' });
                    dialog.result
                        .then(function (jobId) {
                        scope.viewModel.browserOpen = false;
                        $log.info('View report for: ' + jobId);
                        if (jobId !== undefined) {
                            var search = { jobid: jobId };
                            $location.search('jobid', jobId);
                        }
                    }, function () {
                        scope.viewModel.browserOpen = false;
                    });
                };
                scope.ensureJobLoaded = function () {
                    console.log('viewModel', scope.viewModel);
                    if (scope.viewModel.jobId) {
                        scope.viewModel.loadingIndicator.state = true;
                        $log.info('Opening selected job : ' + scope.viewModel.jobId);
                        jobService.job.getJobReport(scope.viewModel.jobId)
                            .then(function () {
                            scope.viewModel.loadingIndicator.state = false;
                            scope.message.error = false;
                            scope.viewModel.job = jobService.job.data;
                            if (scope.viewModel.job.jobContent.targetStats !== undefined) {
                                $log.info('Expected messages : ' + scope.viewModel.job.jobContent.targetStats.totalMessages);
                            }
                            scope.getTotalMessagesByJobId();
                        }, function () {
                            console.log('this is error. ');
                            scope.message.error = true;
                            scope.viewModel.loadingIndicator.state = false;
                        });
                    }
                };
                scope.getTotalMessagesByJobId = function () {
                    messagesService.getTotalMessagesByJobId(scope.viewModel.jobId)
                        .then(function (data) {
                        if (data.total) {
                            scope.viewModel.totalMessages = data.total;
                        }
                    });
                };
                if (angular.isDefined($routeParams.jobid)) {
                    scope.viewModel.jobId = $routeParams.jobid;
                    scope.ensureJobLoaded();
                }
                else {
                    scope.viewModel.browserOpen = false;
                    $timeout(function () {
                        // Delay automatic opening of dialog while we have problems with dual dialogs due to route change event twice
                        // And only if another dialog is not open
                        if (!scope.viewModel.browserOpen && !scope.viewModel.jobId) {
                            scope.openJobBrowser();
                        }
                    }, 1000);
                }
            }
        };
    }
]);
//# sourceMappingURL=appointments-tables.directive.js.map